import { createAction, props } from '@ngrx/store';
// ========= Global ==========
export const setActiveMenuCode = createAction('[Global] Set Active Menu Code', props<{ activeMenuCode: string }>());
